"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[0],{

/***/ 222:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo_with_background.e5d5a182.png","height":616,"width":1539,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEX9/v73+/Lo9ezp9v3O6uak2uxA2bXTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGUlEQVQImWNgZGRkAAMWViZmZhCPiQkiAgABrgAd2PV5WQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 6815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ComponentSwitch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 224 modules
var esm = __webpack_require__(628);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/classNames.ts
var classNames = __webpack_require__(9413);
// EXTERNAL MODULE: ./components/BlurImage.tsx
var BlurImage = __webpack_require__(1166);
// EXTERNAL MODULE: ./components/RichTextRenderer.tsx
var RichTextRenderer = __webpack_require__(6205);
;// CONCATENATED MODULE: ./components/sections/AlternatingWithTestimonial.tsx








var AlternatingWithTestimonial = function(props) {
    var ref;
    var remaning = props.reverse ? 1 : 0;
    var sections = (ref = props.sections) === null || ref === void 0 ? void 0 : ref.map(function(section) {
        return section.icon ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
            icon: esm[section.icon]
        }) : section;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative pt-16 pb-32 overflow-hidden bg-white",
        children: sections === null || sections === void 0 ? void 0 : sections.map(function(section, sectionIdx) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: (0,classNames/* default */.Z)(sectionIdx === 0 ? "relative" : "mt-24"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,classNames/* default */.Z)(sectionIdx % 2 === remaning ? "lg:py-16" : "lg:py-32 lg:col-start-2", "max-w-xl px-4 mx-auto sm:px-6 lg:max-w-none lg:mx-0 lg:px-0"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        section.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex items-center justify-center w-12 h-12 rounded-md bg-primary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section.icon, {
                                                    className: "w-6 h-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-3xl font-extrabold tracking-tight text-gray-900",
                                                    children: section.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4 text-xl text-gray-500",
                                                    children: section.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                        content: section.description.raw
                                                    })
                                                }),
                                                section.button && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: section.buttonLink || "#",
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "inline-flex px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-secondary hover:bg-lime-500",
                                                            children: section.button
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                section.testimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pt-6 mt-8 border-t border-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-base text-gray-500",
                                                    children: section.testimonial.content
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                                className: "mt-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative flex-shrink-0 w-6 h-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                                className: "absolute rounded-full",
                                                                src: ((ref = section.testimonial.image) === null || ref === void 0 ? void 0 : ref.url) || "/avatar-placeholder.svg",
                                                                fill: true,
                                                                alt: section.testimonial.name + " avatar"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-base font-medium text-gray-700",
                                                            children: [
                                                                section.testimonial.name,
                                                                section.testimonial.position && ", ".concat(section.testimonial.position)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,classNames/* default */.Z)(sectionIdx % 2 === remaning ? "" : "lg:col-start-1", "mt-12 sm:mt-16 lg:mt-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                    className: (0,classNames/* default */.Z)(sectionIdx % 2 === remaning ? "lg:left-0" : "lg:right-0", "object-cover w-full shadow-xl rounded-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:h-full lg:w-auto lg:max-w-none"),
                                    src: section.image.url,
                                    alt: section.imageAlt || "",
                                    width: "2022",
                                    height: "1349",
                                    sizes: "(max-width: 768px) 100vw, 50vw"
                                })
                            })
                        })
                    ]
                })
            }, section.id);
        })
    });
};
/* harmony default export */ var sections_AlternatingWithTestimonial = (AlternatingWithTestimonial);

// EXTERNAL MODULE: ./components/PostCard.tsx
var PostCard = __webpack_require__(5745);
;// CONCATENATED MODULE: ./components/sections/Blog3ColumnCard.tsx


var Blog3ColumnCard = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative px-4 pt-16 pb-20 bg-gray-50 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-white h-1/3 sm:h-2/3"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto max-w-7xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                children: props.title
                            }),
                            props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "max-w-2xl mx-auto mt-3 text-xl text-gray-500 sm:mt-4",
                                children: props.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid max-w-lg gap-5 mx-auto mt-12 lg:grid-cols-3 lg:max-w-none",
                        children: (ref = props.posts) === null || ref === void 0 ? void 0 : ref.map(function(post) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                                post: post
                            }, post.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sections_Blog3ColumnCard = (Blog3ColumnCard);

;// CONCATENATED MODULE: ./components/sections/CallToAction.tsx


var CallToAction = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:flex lg:items-center lg:justify-between lg:py-16 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block",
                            children: props.highlightedTitlePrefix
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block text-primary",
                            children: props.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex mt-8 lg:mt-0 lg:flex-shrink-0",
                    children: [
                        props.primaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex rounded-md shadow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: props.primaryButtonLink || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "inline-flex items-center justify-center px-5 py-3 text-base font-medium text-white border border-transparent rounded-md bg-secondary hover:bg-lime-500",
                                    children: props.primaryButton
                                })
                            })
                        }),
                        props.secondaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex ml-3 rounded-md shadow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: props.secondaryButtonLink || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "inline-flex items-center justify-center px-5 py-3 text-base font-medium bg-white border border-transparent rounded-md text-primary hover:bg-indigo-50",
                                    children: props.secondaryButton
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sections_CallToAction = (CallToAction);

;// CONCATENATED MODULE: ./components/sections/Centered2ColumnFeature.tsx





var Centered2ColumnFeature = function(props) {
    var ref;
    var features = (ref = props.features) === null || ref === void 0 ? void 0 : ref.map(function(feature) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, feature), {
            icon: esm[feature.icon]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-12 bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-base font-semibold tracking-wide uppercase text-primary",
                            children: props.superTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl",
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "max-w-2xl mt-4 text-xl text-gray-500 lg:mx-auto",
                            children: props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10",
                        children: features === null || features === void 0 ? void 0 : features.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: feature.link || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                            children: [
                                                feature.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute flex items-center justify-center w-12 h-12 text-white rounded-md bg-primary",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                        className: "w-6 h-6",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ml-16 text-lg font-medium leading-6 text-gray-900",
                                                    children: feature.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "mt-2 ml-16 text-base text-gray-500",
                                            children: feature.description
                                        })
                                    ]
                                })
                            }, feature.id);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_Centered2ColumnFeature = (Centered2ColumnFeature);

;// CONCATENATED MODULE: ./components/sections/Centered3ColumnFeature.tsx





var Centered3ColumnFeature = function(props) {
    var ref;
    var features = (ref = props.features) === null || ref === void 0 ? void 0 : ref.map(function(feature) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, feature), {
            icon: esm[feature.icon]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative py-16 bg-white sm:py-24 lg:py-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-base font-semibold tracking-wider uppercase text-primary",
                    children: props.superTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mx-auto mt-5 text-xl text-gray-500 max-w-prose",
                    children: props.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3",
                        children: features === null || features === void 0 ? void 0 : features.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: feature.link || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "pt-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flow-root px-6 pb-8 rounded-lg bg-gray-50",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "-mt-6",
                                            children: [
                                                feature.icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "inline-flex items-center justify-center p-3 rounded-md shadow-lg bg-primary",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                            className: "w-6 h-6 text-white",
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pt-3"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "mt-8 text-lg font-medium tracking-tight text-gray-900",
                                                    children: feature.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-5 text-base text-gray-500",
                                                    children: feature.description
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, feature.name);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_Centered3ColumnFeature = (Centered3ColumnFeature);

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(1782);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./components/sections/CenteredAccordion.tsx






var CenteredAccordion = function(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* FAQPageJsonLd */.Mg, {
                mainEntity: ((ref = props.questions) === null || ref === void 0 ? void 0 : ref.map(function(q) {
                    return {
                        questionName: q.question,
                        acceptedAnswerText: q.answer.text
                    };
                })) || []
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-4 py-12 mx-auto max-w-7xl sm:py-16 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-3xl mx-auto divide-y-2 divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold text-center text-gray-900 sm:text-4xl",
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                className: "mt-6 space-y-6 divide-y divide-gray-200",
                                children: (ref1 = props.questions) === null || ref1 === void 0 ? void 0 : ref1.map(function(faq) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                        as: "div",
                                        className: "pt-6",
                                        children: function(param) {
                                            var open = param.open;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                        className: "text-lg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                                            className: "flex items-start justify-between w-full text-left text-gray-400",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-medium text-gray-900",
                                                                    children: faq.question
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "flex items-center ml-6 h-7",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                                                        className: (0,classNames/* default */.Z)(open ? "-rotate-180" : "rotate-0", "h-6 w-6 transform"),
                                                                        "aria-hidden": "true"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                        as: "dd",
                                                        className: "pr-12 mt-2",
                                                        unmount: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-base text-gray-500",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                                content: faq.answer.raw
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        }
                                    }, faq.question);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var sections_CenteredAccordion = (CenteredAccordion);

;// CONCATENATED MODULE: ./components/sections/OffsetWithSupportingText.tsx



var OffsetWithSupportingText = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:py-20 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:grid lg:grid-cols-3 lg:gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold text-gray-900",
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-lg text-gray-500",
                                children: props.description
                            }),
                            props.button && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: props.buttonLink || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "inline-flex items-center px-4 py-2 mt-6 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-secondary hover:bg-indigo-700",
                                        children: props.button
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-12 lg:mt-0 lg:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                            className: "space-y-12",
                            children: (ref = props.questions) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "text-lg font-medium leading-6 text-gray-900",
                                            children: item.question
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "mt-2 text-base text-gray-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                content: item.answer.raw
                                            })
                                        })
                                    ]
                                }, item.question);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var sections_OffsetWithSupportingText = (OffsetWithSupportingText);

// EXTERNAL MODULE: ./components/sections/SimpleCenteredHeader.tsx
var SimpleCenteredHeader = __webpack_require__(7011);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/PhoneIcon.js
var PhoneIcon = __webpack_require__(9092);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MailIcon.js
var MailIcon = __webpack_require__(9700);
// EXTERNAL MODULE: ./node_modules/@uploadcare/react-widget/dist/esm/index-316d90fa.js
var index_316d90fa = __webpack_require__(8874);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./components/SocialMediaIcons.tsx
var SocialMediaIcons = __webpack_require__(1692);
;// CONCATENATED MODULE: ./components/sections/SplitBrandContactForm.tsx










var SplitBrandContactForm = function(props) {
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var ref1 = (0,react.useState)(), files = ref1[0], setFiles = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-100",
        id: "contact-us",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative bg-white shadow-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "sr-only",
                        children: "Contact us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative px-6 py-10 overflow-hidden bg-primary sm:px-10 xl:p-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-0 pointer-events-none sm:hidden",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            className: "absolute inset-0 w-full h-full",
                                            width: 343,
                                            height: 388,
                                            viewBox: "0 0 343 388",
                                            fill: "none",
                                            preserveAspectRatio: "xMidYMid slice",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M-99 461.107L608.107-246l707.103 707.107-707.103 707.103L-99 461.107z",
                                                    fill: "url(#linear1)",
                                                    fillOpacity: ".1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                        id: "linear1",
                                                        x1: "254.553",
                                                        y1: "107.554",
                                                        x2: "961.66",
                                                        y2: "814.66",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                stopColor: "#fff"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                offset: 1,
                                                                stopColor: "#fff",
                                                                stopOpacity: 0
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 bottom-0 right-0 hidden w-1/2 pointer-events-none sm:block lg:hidden",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            className: "absolute inset-0 w-full h-full",
                                            width: 359,
                                            height: 339,
                                            viewBox: "0 0 359 339",
                                            fill: "none",
                                            preserveAspectRatio: "xMidYMid slice",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M-161 382.107L546.107-325l707.103 707.107-707.103 707.103L-161 382.107z",
                                                    fill: "url(#linear2)",
                                                    fillOpacity: ".1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                        id: "linear2",
                                                        x1: "192.553",
                                                        y1: "28.553",
                                                        x2: "899.66",
                                                        y2: "735.66",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                stopColor: "#fff"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                offset: 1,
                                                                stopColor: "#fff",
                                                                stopOpacity: 0
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 bottom-0 right-0 hidden w-1/2 pointer-events-none lg:block",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            className: "absolute inset-0 w-full h-full",
                                            width: 160,
                                            height: 678,
                                            viewBox: "0 0 160 678",
                                            fill: "none",
                                            preserveAspectRatio: "xMidYMid slice",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M-161 679.107L546.107-28l707.103 707.107-707.103 707.103L-161 679.107z",
                                                    fill: "url(#linear3)",
                                                    fillOpacity: ".1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                        id: "linear3",
                                                        x1: "192.553",
                                                        y1: "325.553",
                                                        x2: "899.66",
                                                        y2: "1032.66",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                stopColor: "#fff"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                                offset: 1,
                                                                stopColor: "#fff",
                                                                stopOpacity: 0
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg font-medium text-white",
                                        children: props.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "max-w-3xl mt-6 text-base text-indigo-50",
                                        children: props.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                        className: "mt-8 space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Phone number"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "tel:+447503753001",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                    className: "flex text-base text-indigo-50",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* default */.Z, {
                                                            className: "flex-shrink-0 w-6 h-6 text-indigo-200 cursor-pointer",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ml-3 cursor-pointer",
                                                            children: "+44 750 375 3001"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Phone number"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "tel:+905413625030",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                    className: "flex text-base text-indigo-50",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* default */.Z, {
                                                            className: "flex-shrink-0 w-6 h-6 text-indigo-200 cursor-pointer",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ml-3 cursor-pointer",
                                                            children: "+90 541 362 5030"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Email"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "mailto:info@welfareabroad.com",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                    className: "flex text-base text-indigo-50",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MailIcon/* default */.Z, {
                                                            className: "flex-shrink-0 w-6 h-6 text-indigo-200 cursor-pointer",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ml-3 cursor-pointer",
                                                            children: "info@welfareabroad.com"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaIcons/* default */.Z, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-6 py-10 sm:px-10 lg:col-span-2 xl:p-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg font-medium text-gray-900",
                                        children: "Send us a message"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: "grid grid-cols-1 mt-6 gap-y-6 sm:grid-cols-2 sm:gap-x-8",
                                        method: "POST",
                                        action: "https://submit-form.com/6ABk13kx",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                htmlFor: "firstName",
                                                                className: "block text-sm font-medium text-gray-900",
                                                                children: [
                                                                    "First name",
                                                                    " "
                                                                ]
                                                            }),
                                                            errors.firstName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-sm text-red-500",
                                                                children: "* Required"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                            type: "text",
                                                            autoComplete: "given-name",
                                                            className: "block w-full px-4 py-3 text-gray-900 border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
                                                        }, register("firstName", {
                                                            required: true
                                                        })))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                htmlFor: "lastName",
                                                                className: "block text-sm font-medium text-gray-900",
                                                                children: [
                                                                    "Last name",
                                                                    " "
                                                                ]
                                                            }),
                                                            errors.lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-sm text-red-500",
                                                                children: "* Required"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                            type: "text",
                                                            autoComplete: "family-name",
                                                            className: "block w-full px-4 py-3 text-gray-900 border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
                                                        }, register("lastName", {
                                                            required: true
                                                        })))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "email",
                                                                className: "block text-sm font-medium text-gray-900",
                                                                children: "Email"
                                                            }),
                                                            errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-sm text-red-500",
                                                                children: "* Required"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                            type: "email",
                                                            autoComplete: "email",
                                                            className: "block w-full px-4 py-3 text-gray-900 border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
                                                        }, register("email", {
                                                            required: true
                                                        })))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "phone",
                                                                className: "block text-sm font-medium text-gray-900",
                                                                children: "Phone"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                id: "phone-optional",
                                                                className: "text-sm text-gray-500",
                                                                children: "Optional"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                            type: "text",
                                                            autoComplete: "tel",
                                                            className: "block w-full px-4 py-3 text-gray-900 border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary",
                                                            "aria-describedby": "phone-optional"
                                                        }, register("phone")))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sm:col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-between",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "subject",
                                                            className: "block text-sm font-medium text-gray-900",
                                                            children: "Subject"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            className: "block w-full px-4 py-3 text-gray-900 border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
                                                        }, register("subject")), {
                                                            defaultValue: "Hair Transplant",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "Hair Transplant",
                                                                    children: "Hair Transplant"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "Cosmetic Surgeries",
                                                                    children: "Cosmetic Surgeries"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: "Affiliate",
                                                                    children: "Affiliate"
                                                                })
                                                            ]
                                                        }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sm:col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "message",
                                                                className: "block text-sm font-medium text-gray-900",
                                                                children: "Message"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex justify-between space-x-3",
                                                                children: [
                                                                    errors.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-sm text-red-500",
                                                                        children: "* Required"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        id: "message-max",
                                                                        className: "text-sm text-gray-500",
                                                                        children: "Max. 500 characters"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                                            id: "message",
                                                            rows: 4,
                                                            className: "block w-full px-4 py-3 text-gray-900 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary",
                                                            "aria-describedby": "message-max",
                                                            defaultValue: ""
                                                        }, register("message", {
                                                            required: true
                                                        })))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sm:col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "message",
                                                                className: "block text-sm font-medium text-gray-900",
                                                                children: "Your Photos"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex justify-between space-x-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    id: "message-max",
                                                                    className: "text-sm text-gray-500",
                                                                    children: "Optional"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt-1 text-black",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "hidden",
                                                                name: "photos",
                                                                value: files || ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_316d90fa.W, {
                                                                publicKey: "b6bd92b97732ab778e9c",
                                                                tabs: "file camera",
                                                                localeTranslations: {
                                                                    buttons: {
                                                                        choose: {
                                                                            files: {
                                                                                other: "Choose files to upload"
                                                                            }
                                                                        }
                                                                    }
                                                                },
                                                                multiple: true,
                                                                onChange: function(info) {
                                                                    setFiles(info.cdnUrl);
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "sm:col-span-2 sm:flex sm:justify-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "submit",
                                                    className: (0,classNames/* default */.Z)(isSubmitting ? "bg-gray-500" : "bg-secondary hover:bg-lime-500 focus:ring-2 focus:ring-offset-2 focus:ring-primary focus:outline-none", "inline-flex items-center justify-center w-full px-6 py-3 mt-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm sm:w-auto"),
                                                    disabled: isSubmitting,
                                                    children: "Submit"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var sections_SplitBrandContactForm = (SplitBrandContactForm);

// EXTERNAL MODULE: ./public/logo_with_background.png
var logo_with_background = __webpack_require__(222);
;// CONCATENATED MODULE: ./components/sections/SplitHero.tsx




var SplitHero = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full pt-16 pb-20 mx-auto text-center max-w-7xl lg:py-48 lg:text-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 lg:w-1/2 sm:px-8 xl:pr-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block xl:inline",
                                    children: props.title
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block text-primary xl:inline",
                                    children: props.highlightedTitleSuffix
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "max-w-md mx-auto mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl",
                            children: props.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-10 sm:flex sm:justify-center lg:justify-start",
                            children: [
                                props.primaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-md shadow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: props.primaryButtonLink || "#",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white border border-transparent rounded-md bg-secondary hover:bg-lime-500 md:py-4 md:text-lg md:px-10",
                                            children: props.primaryButton
                                        })
                                    })
                                }),
                                props.secondaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3 rounded-md shadow sm:mt-0 sm:ml-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: props.secondaryButtonLink || "#",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium bg-white border border-transparent rounded-md text-primary hover:bg-gray-50 md:py-4 md:text-lg md:px-10",
                                            children: props.secondaryButton
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                    className: "absolute object-cover object-left-top w-full h-full",
                    src: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.url) || logo_with_background/* default */.Z,
                    width: "2022",
                    height: "1349",
                    alt: props.imageAlt || props.title || "",
                    priority: true,
                    sizes: "(max-width: 768px) 100vw, 50vw"
                })
            })
        ]
    });
};
/* harmony default export */ var sections_SplitHero = (SplitHero);

;// CONCATENATED MODULE: ./components/sections/Team.tsx




var Team = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:col-span-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        className: "space-y-12 sm:divide-y sm:divide-gray-200 sm:space-y-0 sm:-mt-8 lg:gap-x-8 lg:space-y-0",
                        children: (ref = props.members) === null || ref === void 0 ? void 0 : ref.map(function(person) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                className: "sm:py-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4 sm:grid sm:grid-cols-3 sm:items-start sm:gap-6 sm:space-y-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "aspect-w-3 aspect-h-2 sm:aspect-w-3 sm:aspect-h-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                className: "object-cover rounded-lg shadow-lg",
                                                src: ((ref = person.image) === null || ref === void 0 ? void 0 : ref.url) || logo_with_background/* default */.Z,
                                                alt: person.name,
                                                fill: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sm:col-span-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-1 text-lg font-medium leading-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: person.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-indigo-600",
                                                                children: person.speciality.join(" / ")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-lg text-gray-500",
                                                        children: person.resume && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                            content: person.resume.raw
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }, person.name);
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var sections_Team = (Team);

;// CONCATENATED MODULE: ./components/sections/TestimonialsWithOverlappingImage.tsx



var TestimonialsWithOverlappingImage = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: props.testimonials && ((ref = props.testimonials) === null || ref === void 0 ? void 0 : ref.map(function(testimonial, testimonialIdx) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: "pt-16 bg-white lg:py-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-16 bg-primary lg:pb-0 lg:z-10 lg:relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,classNames/* default */.Z)(testimonialIdx % 2 === 0 ? "" : "order-last", "relative lg:-my-8"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: "absolute inset-x-0 top-0 bg-white h-1/2 lg:hidden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "max-w-md px-4 mx-auto sm:max-w-3xl sm:px-6 lg:p-0 lg:h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "overflow-hidden shadow-xl bg-secondary aspect-w-10 aspect-h-10 rounded-xl lg:h-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                className: "object-contain lg:h-full lg:w-full rounded-xl",
                                                src: (testimonial === null || testimonial === void 0 ? void 0 : (ref = testimonial.image) === null || ref === void 0 ? void 0 : ref.url) || "/avatar-placeholder.svg",
                                                alt: testimonial.name + "'s testimonial",
                                                sizes: "100vw",
                                                fill: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,classNames/* default */.Z)(testimonialIdx % 2 === 0 ? "lg:pl-8" : "lg:pr-8", "mt-12 lg:m-0"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-md px-4 mx-auto sm:max-w-2xl sm:px-6 lg:px-0 lg:py-20 lg:max-w-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        className: "w-12 h-12 text-white opacity-25",
                                                        fill: "currentColor",
                                                        viewBox: "0 0 32 32",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-6 text-2xl font-medium text-white",
                                                        children: testimonial.content
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-medium text-white",
                                                        children: testimonial.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-medium text-indigo-100",
                                                        children: testimonial.position
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }, testimonial.id);
        }))
    });
};
/* harmony default export */ var sections_TestimonialsWithOverlappingImage = (TestimonialsWithOverlappingImage);

;// CONCATENATED MODULE: ./components/ComponentSwitch.tsx














var ComponentSwitch = function(props) {
    var elemetns = props.components.map(function(component) {
        switch(component.__typename){
            case "SimpleCenteredHeader":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleCenteredHeader/* default */.Z, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Centered2ColumnFeature":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Centered2ColumnFeature, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "CenteredAccordion":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CenteredAccordion, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "CallToAction":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CallToAction, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "AlternatingWithTestimonial":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_AlternatingWithTestimonial, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "SplitBrandContactForm":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_SplitBrandContactForm, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "TestimonialsWithOverlappingImage":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_TestimonialsWithOverlappingImage, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Centered3ColumnFeature":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Centered3ColumnFeature, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "SplitHero":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_SplitHero, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "OffsetWithSupportingText":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_OffsetWithSupportingText, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Blog3ColumnCard":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Blog3ColumnCard, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Team":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Team, (0,_object_spread/* default */.Z)({}, component), component.id);
            default:
                return undefined;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: elemetns
    });
};
/* harmony default export */ var components_ComponentSwitch = (ComponentSwitch);


/***/ }),

/***/ 6000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _ComponentSwitch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6815);
/* harmony import */ var _RichTextRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6205);




var Page = function(param) {
    var page = param.page;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: page.seo.title || page.title || "",
                description: page.seo.description || page.description || "",
                noindex: page.seo.noIndex,
                openGraph: {
                    title: page.seo.title || page.title || "",
                    description: page.seo.description || page.description || ""
                }
            }),
            page.highlightedTitlePrefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative py-12 overflow-hidden bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative px-4 sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mx-auto text-lg max-w-prose",
                            children: [
                                (page.highlightedTitlePrefix || page.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-base font-semibold tracking-wide text-center text-indigo-600 uppercase",
                                            children: page.highlightedTitlePrefix
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 sm:text-4xl",
                                            children: page.title
                                        })
                                    ]
                                }),
                                page.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-8 text-xl leading-8 text-gray-500",
                                    children: page.description
                                })
                            ]
                        }),
                        ((ref = page.content) === null || ref === void 0 ? void 0 : ref.raw) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mx-auto mt-6 prose prose-lg text-gray-500 prose-green",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RichTextRenderer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                content: (ref1 = page.content) === null || ref1 === void 0 ? void 0 : ref1.raw
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative overflow-hidden",
                children: page.components && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ComponentSwitch__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    components: page.components
                })
            }),
            ((ref2 = page.content) === null || ref2 === void 0 ? void 0 : ref2.raw) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto mt-6 prose prose-lg text-gray-500 prose-green",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RichTextRenderer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    content: (ref3 = page.content) === null || ref3 === void 0 ? void 0 : ref3.raw
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 5745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_logo_with_background_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(222);
/* harmony import */ var _BlurImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1166);




var PostCard = function(param) {
    var post = param.post;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col overflow-hidden rounded-lg shadow-lg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-shrink-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BlurImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "object-cover w-full h-48 rounded-xl",
                    width: 413,
                    height: 192,
                    src: ((ref = post.image) === null || ref === void 0 ? void 0 : ref.url) || _public_logo_with_background_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                    alt: post.imageAlt || post.title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col justify-between flex-1 p-6 bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm font-medium text-indigo-600",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: post.categories.slice(-1)[0].seo.slug,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "hover:underline",
                                    children: post.categories.slice(-1)[0].name
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/" + [
                                post.categories.slice(-1)[0].seo.slug,
                                post.seo.slug
                            ].join("/"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "block mt-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xl font-semibold text-gray-900",
                                        children: post.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-3 text-base text-gray-500",
                                        children: post.description
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCard);


/***/ }),

/***/ 6205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _graphcms_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(392);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);






var RichTextRenderer = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_graphcms_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
        content: props.content,
        renderers: {
            a: function(_param) {
                var children = _param.children, openInNewTab = _param.openInNewTab, href = _param.href, rel = _param.rel, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                    "children",
                    "openInNewTab",
                    "href",
                    "rel"
                ]);
                if (href === null || href === void 0 ? void 0 : href.match(/^https?:\/\/|^\/\//i)) {
                    return(// eslint-disable-next-line react/jsx-no-target-blank
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        href: href,
                        target: openInNewTab ? "_blank" : "_self",
                        rel: rel || "noopener noreferrer"
                    }, rest), {
                        children: children
                    })));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: href || "#",
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
                        children: children
                    }))
                });
            },
            p: function(_param) {
                var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                    "children"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "mt-4 text-gray-500"
                }, rest), {
                    children: children
                }));
            },
            h2: function(_param) {
                var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                    "children"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "text-3xl font-extrabold tracking-tight text-gray-900"
                }, rest), {
                    children: children
                }));
            },
            h3: function(_param) {
                var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                    "children"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    className: "mt-4 text-xl font-bold"
                }, rest), {
                    children: children
                }));
            }
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RichTextRenderer);


/***/ })

}]);